module.exports = __webpack_public_path__ + "static/metaver-2df8530a91d59d67428d6f210ded82ee.png";